module.exports = __webpack_public_path__ + "img/import_pdf_arrow-24px.f65b4fd2.svg";